/// <summary>
/// This object does the complete menu and highchart handling in the subSignalMenu. <br/>
/// It generates proper ramp and ramp signal parameters, does the date handling and menu hiding/showing stuff. 
/// Author: MWI<br />
/// Date: 9.11.2015<br />
/// Copyright ©: EUDT GmbH 2015 <br />
/// Version-History:<br />
/// **********************************************************************<br />
/// *** v1.0.7 - 13.09.2017                                              *<br />
/// **********************************************************************<br />
/// * - new tagged search other improvments                              *<br />
/// **********************************************************************<br />
/// **********************************************************************<br />
/// *** v1.0.6 - 30.06.2017                                             *<br />
/// **********************************************************************<br />
/// * - fixed bug with showing loading if no signal with subsignals is available *<br />
/// **********************************************************************<br />
/// *** v1.0.5 - 26.01.2017                                             *<br />
/// **********************************************************************<br />
/// * - generateChartParameter updated to reflect change in archive menu *<br />
/// **********************************************************************<br />
/// *** v1.0.4 - 07.09.2016                                              *<br />
/// **********************************************************************<br />
/// * -  fixed bug with wrong intervals                                  *<br />
/// **********************************************************************<br />
/// *** v1.0.3 - 05.04.2016                                                *<br />
/// **********************************************************************<br />
/// * -  removed jquery calls and went to me.visual.find                  *<br />
/// **********************************************************************<br />
/// *** v1.0.2 - 10.03.2016                                                *<br />
/// **********************************************************************<br />
/// * -  added loading of prices                                         *<br />
/// **********************************************************************<br />
/// *** v1.0.1 - 17.11.2015                                                *<br />
/// **********************************************************************<br />
/// * -  added documentation                                             *<br />
/// * -  added functions for filtering                                   *<br />
/// * -  added note that not signals where selected                     *<br />
/// **********************************************************************<br />
/// *** v1.0.0 - 9.11.2015                                                *<br />
/// **********************************************************************<br />
/// * -  inherited from rampMenu js                                      *<br />
/// * -  changed only a few functions                                    *<br />
/// **********************************************************************<br />
/// </summary>
function subSignalMenu(visual, vcid, vcgid, userLangid) {
    ///<summary>
    /// creates the object by calling the "super" constructor
    ///</summary>
    this.userLangid = userLangid;
    this.bInit = false;
    window.rampMenu.call(this, visual, vcid, vcgid);
}
//create the prototype based on the rampMenu Object
subSignalMenu.prototype = Object.create(window.rampMenu.prototype);
//set the constructor to this object
subSignalMenu.prototype.constructor = subSignalMenu;

subSignalMenu.prototype.initUserOptions = function () {
    ///<summary>
    ///empty user options function to avoid errors
    ///</summary>
};
subSignalMenu.prototype.getVisualName = function () {
    /// <summary>
    /// This function returns the visual name based on the selected time interval.<br/>
    /// OVERLOAD OF rampMenu
    /// </summary>
    return "VC_CHART_SUBSIGNALS";
};
subSignalMenu.prototype.overridePriceAndCumlulatedOption = function () {
    /// <summary>
    /// this function basically renders the submenu selection buttons unusable <br/>
    /// it removes the click handler from the cumulated button <br/>
    /// and hides all other buttons <br/>
    /// </summary>
    var me = this;
    var bRet = true;
    try {

        if (me.error) {
            bRet = false;
        } else {
            me.visual.find(".submenu .ui-widget-content").unbind("click");
            me.visual.find('#selUsePrice').unbind("click").bind("click", function () {
                //window.vcSignalTopology.prototype.doEvent.call(me, event);
                me.setDirty(true);
                $(this).toggleClass("ui-selected");
                if ($(this).hasClass('ui-selected')) {
                    me.visual.find('#selUsePrice i').show();
                    me.usePrice = true;
                } else {
                    me.visual.find('#selUsePrice i').hide();
                    me.usePrice = false;
                }
                me.param.usePrices = me.usePrice;
            }
            );
        }
    } catch (ex) {
        window.writeError('subSignalMenu.overridePriceAndCumlulatedOption', ex);
        bRet = false;
    }
    return bRet;
};


subSignalMenu.prototype.overrideShowButton = function () {
    /// <summary>
    /// overrides the reload Chart button by setting an own click handler
    /// </summary>
    var me = this;
    try {

        me.visual.find('#btnShowChart').unbind("click").bind("click", function () {          
            me.visual.find("#subsignal-signal-list .vc-list-item.selected").trigger("click");
        });
    } catch (ex) {
        window.writeError('subSignalMenu.js.overrideShowButton', ex);
        return false;
    }
    return false;
};

subSignalMenu.prototype.generateChartParameter = function () {
    /// <summary>
    /// Override of rampMenu.generateChartParameter <br/>
    /// first calls the Method of the Base Class <br/>
    /// simplifies the signalparameter to a single bsaid
    /// and sets cumulated to always true
    /// </summary>
    var me = this;
    var dates;
    try {
        me.rampCharts.getSelectedMenuType = function () { return 0; };
        window.rampMenu.prototype.generateChartParameter.call(me);

       
        dates = me.visual.find("#div-date-box").vcFullDateBox("getDate");
        me.param.startDate = dates.from;
        me.param.endDate = dates.to;
        if (me.visual.find("#div-date-box").vcFullDateBox("getIndex")===1) {
            me.param.dateUserDef = true;
        }
        me.param.dataType = 2;
        me.param.StartingHour = 0;
        //me.chartWidth = parseInt(me.visual.find("#divRamp1").width(), 10);
        me.chartWidth = parseInt(me.visual.width()- 318);
        me.chartHeightSingle =   parseInt(me.visual.height()- 190, 10);
        //me.chartWidth = 720;
        //    me.chartHeightSingle = parseInt(me.chartWidth * 0.562, 10);
        me.param.isCumulated = true;
        me.param.isArchive = false;
        me.param.usePrices = me.visual.find('#selUsePrice').hasClass('ui-selected');
        me.signalParam = {};
        me.param.interval = me.interval;
        me.signalParam.signalID = me.visual.find(".selected").attr('data-id');
        me.signalParam.signalCount = me.visual.find(".selected").attr("data-count");

    } catch (ex) {
        window.writeError('subSignalMeneu.generateChartParameter', ex);
    }
};
subSignalMenu.prototype.init = function () {
    ///<summary>
    ///Overrides the rampMenu.init, by calling it and adding an extra note 
    ///</summary>
    var me = this;
    try {
        window.rampMenu.prototype.init.call(me);
        me.visual.find('#divRamp1').removeClass('error').addClass('note').html(me.resources.noSignalLoaded_lbl).show();
        me.visual.find(".vc-filter").vcFilter({ callback: function () { me.filter(); } });
        me.visual.find("#subsignal-signal-list").height(me.visual.find("#divSignalSelectionList").height() - 81);
    } catch (ex) {
        window.writeError('subSignalMenu.init', ex);
    }
};

subSignalMenu.prototype.events = function () {
    /// <summary>
    /// currently just an empty function to avoid errors and other problems <br/>
    /// </summary>
};


subSignalMenu.prototype.initDateBox = function () {
    /// <summary>
    /// inits the vcFullDateBox
    /// </summary>
    var me = this;
    try {

       
        me.visual.find("#div-date-box").vcFullDateBox({ langID: me.userLangid, callback: function() {
            window.rampMenu.prototype.setDirty.call(me, true);
                me.bInit = true;
            }
        });
        
    } catch (ex) {
        window.writeError('subSignalMenu.js.initDateBox', ex);
        return false;
    }
    return false;
};


subSignalMenu.prototype.changeDateBox = function (inter) {
    /// <summary>
    /// resets the interval and reloads the vcFullDateBox
    /// </summary>
    var me = this;
    try {
        me.visual.find("#div-date-box").vcFullDateBox("option", "interval", inter);
        me.visual.find("#div-date-box").vcFullDateBox("refresh");

    } catch (ex) {
        window.writeError('subSignalMenu.js.changeDateBox', ex);
        return false;
    }
    return false;
};


subSignalMenu.prototype.setInterval = function () {
    var me = this;
    try {

        window.rampMenu.prototype.setInterval.call(me);

      if (me.bInit) {
          me.changeDateBox(me.interval);
      }

        me.visual.find(".vc-list-item").filter(function (idx, element) {
            return parseInt($(element).data("interval"), 10) > parseInt(me.interval, 10);
        }).addClass("inactive").find(".fa-eye-slash").show();
        me.visual.find(".vc-list-item").filter(function (idx, element) {
            return !(parseInt($(element).data("interval"), 10) > parseInt(me.interval, 10));
        }).removeClass("inactive").find(".fa-eye-slash").hide();
    } catch (ex) {
        window.writeError('subSignalMenu.setInterval', ex);
    }
  
};
subSignalMenu.prototype.loadSignals = function () {                                                                                                                       
    /// <summary>
    /// This function loads all available signals in the selection list and adds some basic clickhandlers to them <br/>
    /// </summary>
    var me = this;
    var bRet = true;
    try {
        if (me.error) {
            bRet = false;
        } else {
            window.VisualCoreService.getDataByName(me.getVisualName(), 'subSignals1', window.getCurrentTimestamp(), 0, 0, '', JSON.stringify(me.param), 2, JSON.stringify(me.signalParam), function (result) {
                if (result.length > 0) {
                    me.visual.find("#subsignal-signal-list").html(result);
                    me.visual.find(".rampcharts").toggle();
                    me.visual.find(".vc-list-item").filter(function (idx, element) {
                        return parseInt($(element).data("interval"), 10) > parseInt(me.interval, 10);
                    }).addClass("inactive").find(".fa-eye-slash").show();
                    me.visual.find(".vc-list-item").filter(function (idx, element) {
                        return ! parseInt($(element).data("interval"), 10) > parseInt(me.interval, 10);
                    }).removeClass("inactive").find(".fa-eye-slash").hide();
                    me.visual.find("#subsignal-signal-list .vc-list-item").off("click").on("click",
                        function () {
                            if ($(this).hasClass("inactive") === false) {
                                me.visual.find("#subsignal-signal-list .vc-list-item").toggleClass('selected', false);
                                $(this).toggleClass('selected', true);
                                me.visual.find('#divRamp1').removeClass('note');
                                me.generateChartParameter();
                                me.setDirty(true);

                                window.VisualCoreService.getVisualBaseByName(me.getVisualName(),me.vcid,window.getCurrentTimestamp(),me.chartHeightSingle,me.chartWidth,JSON.stringify(me.param),JSON.stringify(me.signalParam),1,function(res) {
                                        me.visual.find("#divRamp" + me.vcid).html(res);
                                    me.setDirty(false);


                                    _VCMQ.produce(me.visual, "-1", 'GET_EXPORT_URL_SETTINGS',
                                        {
                                            'info': { bsaid: me.signalParam.signalID, name: '', description: '', startDate: me.param.startDate, endDate: me.param.endDate, dateUserDef: me.param.dateUserDef, interval: me.param.interval },
                                            'visualname': "VC_CHART_SUBSIGNALS", 'parameter': JSON.stringify(me.param), 'signalparameter': JSON.stringify(me.signalParam)
                                        });


                                    });
                            }
                        });
                    me.visual.find("#subsignal-signal-list .vc-list-item:not(.inactive)").first().trigger("click");
                    me.loadSignalInformation();
                    me.setInterval();

                } else {
                    me.visual.find('#divRamp1').removeClass('error').addClass('note').html(me.resources.noEntriesExists).show();
                    me.visual.find("#divMenu, #divSignalSelectionList").hide();
                    //me.showInfo(me.resources.noEntriesExist, "", true);
                }
            });
        }
    } catch (ex) {
        window.writeError("subSignalMenu.loadSignals", ex);
        bRet = false;
    }
    return bRet;
};
subSignalMenu.prototype.loadSignalInformation = function () {
    /// <summary>
    /// This function creates a clickHandler bound to the Information icons <br/>
    /// that loads the Signal Analog information table in a extra dialog
    /// </summary>
    var me = this;
    try {

        me.visual.find(".btnSignalInfo").off("click").on("click", function (event) {
            event.stopPropagation();
            me.vcVisual.showSignalAnalogSummaryDialog($(event.target).attr('data-id'));

        });
    } catch (ex) {
        window.writeError('subSignalMenu.js.loadSignalInformation', ex);
    }
};


subSignalMenu.prototype.filter = function () {
    /// <summary>
    /// This function adds/removes two css-classes ('found' and 'exclude') for filtering analog signals.<br/>
    /// When a signal with a filter expression gets found the 'found' class gets added <br/>
    /// At the end, basically all 'found' classes get shown and all others hidden. The core of this function is taken from ARF<br/>
    /// </summary>
    var bRet = true;
    var me = this;
    try {
        if (me.error) {
            bRet = false;
        } else {

            //hide all
            me.visual.find(".vc-list-table .vc-list-item").removeClass("found").data("counter", 0).hide();

            //we add the 'found' class to all items we want to filter based on the vcfilter tags
            me.setTagFilter(".vc-filter", ".vc-list-table .vc-list-item", "found");
            me.visual.find(".vc-list-table .vc-list-item.found").show();
            me.visual.find(".vc-list-table .vc-list-item").removeClass("alt");
            me.visual.find(".vc-list-table .vc-list-item.found:even").addClass("alt");            ////get a list of filter expressions
        
        }
    } catch (ex) {
        window.writeError('subSignalMenu.filter', ex);
        bRet = false;
    }
    return bRet;
};

subSignalMenu.prototype.setTagFilter = function (filterObj, listItem, classFound) {
    /// <summary>
    /// TODO: When RAMPMENU VC-Template then remove
    /// This function takes all tags from the vcFilter widget (filterObj) and adds a 'classFound' css class to all entries it founds in 'listItem'.<br/>
    /// It is used as part of the filter function in vc-lists
    /// </summary>
    var me = this;
    try {
        //we reset the counter for found entries
        me.visual.find(listItem).data('counter', 0);

        //we filter the optional tags we got from the vc-tags
        var filter = me.visual.find(filterObj).vcFilter("getFilter");

        if (filter !== null) {
            var counter;
            //first, we count how often we find the filter tags in every signal item
            for (var i = 0; i <= filter.length - 1; i++) {
                if (filter[i].length > 0) {
                    me.visual.find(listItem + ":contains('" + filter[i] + "')")
                        .each(function () {
                            counter = parseInt($(this).data('counter'), 10);
                            if (isNaN(counter)) {
                                counter = 0; }
                            counter++;
                            $(this).data('counter', counter);
                        });
                }
            }
            //if we found them as often as the number of filter tags - we are the lucky winner and show the entry!!
            //why? if we have several filter tags we have to find all of them in one single signal 
            me.visual.find(listItem)
                .each(function () {
                    if (parseInt($(this).data("counter"), 10) === filter.length) {
                        $(this).addClass(classFound);
                    }
                });
        } else {
            me.visual.find(listItem).addClass(classFound);
        }
    } catch (ex) {
       window.writeError('subSignalMenu.JS.setTagFilter', ex);
    }
};